/**
 * Where a pop-over opens beside the thing that opened it: under it when it fits, over it when it does not,
 * aligned to its left or right edge, and never past the window's edges.
 */
export function placeBeside(
  anchor: DOMRect,
  pop: { width: number; height: number },
  align: "left" | "right" = "left",
  gap = 6,
  edge = 8,
): { top: number; left: number } {
  const below = anchor.bottom + gap + pop.height <= innerHeight - edge || anchor.top - gap - pop.height < edge;
  const top = below ? anchor.bottom + gap : anchor.top - gap - pop.height;
  const want = align === "right" ? anchor.right - pop.width : anchor.left;
  const left = Math.max(edge, Math.min(want, innerWidth - pop.width - edge));
  return { top: Math.round(top), left: Math.round(left) };
}
